import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";

import { styles } from "./UserProfileLists.style";

import "../PlaceListEditor/PlaceListEditor";

@customElement("ds-user-profile-lists")
export class UserProfileLists extends BaseElement {
    static override styles = [styles, LightTheme];

    override render() {
        return html`<div class="container flex-row">
            <ds-place-list-editor></ds-place-list-editor>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-user-profile-lists": UserProfileLists;
    }
}
